import { useEffect, useRef } from 'react'
import { rfStore } from '../lib/rfstore'

/**
 * Leitura grande de frequência.
 *
 * Em laço de animação, não em render do React: arrastar o dial muda a
 * frequência dezenas de vezes por segundo, e `setFreq` não notifica o React de
 * propósito. Mesmo padrão do S-meter e do RXReadout.
 *
 * Números em monoespaçada tabular: 145.500 e 145.525 precisam alinhar dígito a
 * dígito, como na escala impressa de um dial.
 */
export function FreqReadout() {
  const ref = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    let raf = 0
    let ultimo = ''
    const tick = () => {
      const t = (rfStore.snapshot().freqKHz / 1000).toFixed(3)
      if (t !== ultimo) {
        el.textContent = t
        ultimo = t
      }
      raf = requestAnimationFrame(tick)
    }
    raf = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(raf)
  }, [])

  return <span ref={ref}>—</span>
}
